export const CHEMICAL_ACTIONS = {
    CHEMICAL_LIST : "CHEMICAL_LIST"
}